// assets
// hmc assets
import networksImg from "../assets/images/Cell-Tower.png";
import remoteWorkImg from "../assets/images/Work-From-Home.png";
import cloudComputingImg from "../assets/images/Cloud-Computing.png";
import artificialIntelligenceImg from "../assets/images/Artificial-Intelligence.png";
import iotImg from "../assets/images/AI-Chip.png";
import autonomousCarsImg from "../assets/images/Autonomous-Cars.png";
import deviceConnectivityImg from "../assets/images/Connected-Devices.png";
import vrImg from "../assets/images/Virtual-Reality.png";
// import smartCitiesImg from "../assets/images/70x70-SMARTCITIES.png";
// import cyberSecurityImg from "../assets/images/70x70-CYBERSECURITY.png";
// import edgeComputingImg from "../assets/images/70x70-EDGECOMPUTING.png";
// import robotsImg from "../assets/images/70x70-ROBOTS.png";

// Investment Focus
import cellTowersImg from "../assets/images/5G-Cell-Tower.jpg";
import dataCentersImg from "../assets/images/Data-Center-Interior.jpg";
import fiberNetworksImg from "../assets/images/High-Speed-Fiber-Networks.jpg";

export const hmcAssets = [
  {
    title: "5G Networks",
    image: networksImg,
    alt: "Cell Tower",
  },
  {
    title: "IoT",
    image: iotImg,
    alt: "AI Chip",
  },
  {
    title: "Artificial Intelligence",
    image: artificialIntelligenceImg,
    alt: "Artificial Intelligence",
  },
  {
    title: "Virtual Reality",
    image: vrImg,
    alt: "Virtual Reality",
  },
  {
    title: "Device Connectivity",
    image: deviceConnectivityImg,
    alt: "Connected Devices",
  },
  {
    title: "Cloud Computing",
    image: cloudComputingImg,
    alt: "Cloud Computing",
  },
  {
    title: "Remote Work",
    image: remoteWorkImg,
    alt: "Work From Home",
  },
  {
    title: "Autonomous Cars",
    image: autonomousCarsImg,
    alt: "Autonomous Cars",
  },
  // {
  //   title: "Cybersecurity",
  //   image: cyberSecurityImg,
  // },
  // {
  //   title: "Smart Cities",
  //   image: smartCitiesImg,
  // },
  // {
  //   title: "Edge Computing",
  //   image: edgeComputingImg,
  // },
  // {
  //   title: "Robots",
  //   image: robotsImg,
  // },
];

export const InvestmentFocusLib = [
  {
    image: dataCentersImg,
    title: "Data Centers",
    info: `Data centers house rows of hi-tech computing
    equipment to collect, store, and process
    enormous amounts of data that helps keep
    our modern world running.`,
    alt: `A modern data center
representing StratCap Digital
Infrastructure REIT’s strategic
focus on investing in essential
digital infrastructure.`,
  },
  {
    image: cellTowersImg,
    title: "Cell Towers",
    info: `Cell towers house antennas that connect your
    mobile device to the vast cellular network,
    ensuring a seamless connection.`,
    alt: `Cell tower representing StratCap
Digital Infrastructure REIT’s
investment focus on critical
assets that support 5G and
mobile connectivity.`,
  },
  {
    image: fiberNetworksImg,
    title: "Fiber Networks",
    info: `Fiber networks connect everything together.
    They transmit data through pulses of light,
    enabling the rapid and efficient transfer of
    information over long distances.`,
    alt: `Fiber optic cable, a critical
component of StratCap Digital
Infrastructure REIT’s focus on
high-speed connectivity and
next-generation networks.`,
  },
];

export const howDiWorksLib = [
  {
    number: "1",
    info: `Your phone’s map application sends a request for data to
    the nearest cell tower via radio frequency signal`,
  },
  {
    number: "2",
    info: `The signal travels down cabling on the tower and is
    connected to the internet via a fiber network`,
  },
  {
    number: "3",
    info: `Your request travels via fiber to a data center where the
    GPS navigation system resides`,
  },
  {
    number: "4",
    info: `Data is then sent back through fiber, up the tower, and
    back out to your phone telling you where to go`,
  },
];
